import { useContext, useState } from "react"
import { useForm } from "react-hook-form"
import { Button, Form } from "react-bootstrap"
import { Box, Typography } from "@mui/material"
import SearchIcon from '@mui/icons-material/Search';
import { yupResolver } from "@hookform/resolvers/yup"
import { getPersonInfo, searchUserSchema, toggleRolInspector } from "./handlers"
import TextInput from "../../components/ReactHookForm/TextInput"
import ContainedMuniSpinner from '../../components/MuniSpinner/ContainedMuniSpinner'
import PulseOpacitySpinner from '../../components/MuniSpinner/PulseOpacitySpinner'
import { UserContext } from "../../context";
import SelectInput from "../../components/ReactHookForm/SelectInput";
import { getPersonSchema } from "../Actas/handlers";

const FormBuscarUsuario = (props) => {
  const { setSearchUserModalIsOpen } = props
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingToggle, setIsLoadingToggle] = useState(false)
  const [userInfo, setUserInfo] = useState(null)
  const { actions: ua } = useContext(UserContext)

  const { register, handleSubmit, formState: { errors, }, } = useForm({
    mode: 'all',
    resolver: yupResolver(getPersonSchema)
  })

  return (
    <Box>
      <Form onSubmit={handleSubmit((data) => getPersonInfo(data, setUserInfo, setIsLoading))}>
        <fieldset disabled={isLoading} >
          <Box className="d-flex gap-4">
            <TextInput name='dni' label='DNI * ' register={register} errors={errors?.dni} />
            <SelectInput name={`gender`} errors={errors.gender} label="Género *" register={register} data={[
              { id: 'M', name: 'M (masculino)' },
              { id: 'F', name: 'F (femenino)' },
              { id: 'X', name: 'X' },
            ]} />
            <Button type="submit" className="" disabled={isLoading} style={{ height: '38px', marginTop: '32px', alignSelf: 'flex-middle' }}>
              {isLoading ? <Box className="w-full h-full">
                <ContainedMuniSpinner height={25} width={25} size={35} /> </Box> : <SearchIcon />}
            </Button>
          </Box>
        </fieldset>
      </Form>
      {userInfo && (
        <>
          <ul>
            <li>ID: {userInfo.id}</li>
            <li>DNI: {userInfo.dni}</li>
            <li>Nombre completo: {userInfo.nombre}</li>
          </ul>
          <Box>
            <Typography style={{ marginBottom: '1rem', fontWeight: "bold", color: userInfo.inspector ? '#1334C9' : '#EF4444', }}>{userInfo.nombre} {userInfo.inspector ? "es inspector." : "no es inspector."}</Typography>
            {((ua.hasPermission('usuarios.edit')) || ua.hasPermission('usuarios.create')) && (
              <Box className="gap-2">
                {isLoadingToggle ? <PulseOpacitySpinner /> :
                  <div className="d-flex gap-2">
                    <Button onClick={() =>
                      toggleRolInspector(userInfo, setUserInfo, setIsLoadingToggle)
                    }>
                      {(!userInfo.inspector)
                        ? 'Agregar rol de inspector'
                        : 'Remover rol de inspector'
                      }
                    </Button>
                    <Button variant='danger' onClick={() => setSearchUserModalIsOpen(false)}>Cerrar</Button>
                  </div>
                }
              </Box>
            )}
          </Box>
        </>
      )}
    </Box>
  )
}

export default FormBuscarUsuario